import { BeltSyllabus } from './types';

export const yellowBelt: BeltSyllabus = {
    id: 'yellow',
    name: 'Yellow Belt',
    color: '#ffe135',
    theoryUnder13: [
        {
            title: 'Theory',
            items: [
                {
                    question: 'What does Dan-Gun mean?',
                    answer: 'Dan-Gun was the man who founded Korea in 2333 BC'
                },
                {
                    question: 'How many movements in Dan-Gun?',
                    answer: '21'
                },
                {
                    question: 'What is the diagram of Dan-Gun?',
                    answer: '/assets/diagrams/dan_gun_diagram.png',
                    isImage: true
                },
                {
                    question: 'What does the colour of the Yellow Belt mean?',
                    answer: 'Yellow signifies the earth from which a plant sprouts, as the Taekwon-Do skills take root'
                },
                {
                    question: 'What is the third tenet of Taekwon-Do?',
                    answer: 'Perseverance'
                },
                {
                    question: 'What does Perseverance mean?',
                    answer: 'To be patient, to keep trying even after failure'
                }
            ]
        },
        {
            title: 'Korean Terms',
            items: [
                { question: 'Backfist', answer: 'Dung Joomok' },
                { question: 'Thrust', answer: 'Tulgi' },
                { question: 'Side Kick', answer: 'Yop Chagi' },
                { question: 'Fingertip', answer: 'Sonkut' },
                { question: 'Footsword', answer: 'Balkal' },
                { question: 'Ball of the Foot', answer: 'Ap Kumchi' },
                { question: 'Left', answer: 'Wen' },
                { question: 'Right', answer: 'Orun' }
            ]
        }
    ],
    theoryOver13: [
        {
            title: 'Theory',
            items: [
                {
                    question: 'What is the meaning of Dan-Gun?',
                    answer: 'Dan-Gun is named after the holy Dan Gun, the legendary founder of Korea in the year 2333 BC'
                },
                {
                    question: 'Note',
                    answer: 'Note that "Dan-Gun" is pronounced "Dan-Goon"'
                },
                {
                    question: 'How many movements in Dan-Gun?',
                    answer: '21'
                },
                {
                    question: 'What is the diagram of Dan-Gun?',
                    answer: '/assets/diagrams/dan_gun_diagram.png',
                    isImage: true
                },
                {
                    question: 'What does the Yellow Belt signify?',
                    answer: 'Yellow signifies the earth from which a plant sprouts and takes root as the Taekwon-Do foundation is laid.'
                },
                {
                    question: 'What is Continuous Motion?',
                    answer: 'Techniques performed in Continuous Motion (Iojin Tongjak) are performed one after the other with no pause between the end of one movement and the start of the next. There is one breath control for each technique and a Sine Wave for each move. Continuous Motion always starts with a block. The main reason for continuous motion is to allow an instant response to an attack, either by blocking the next technique or issuing your own counter-attack.'
                }
            ]
        },
        {
            title: 'Korean Terms',
            items: [
                { question: 'Backfist', answer: 'Dung Joomok' },
                { question: 'Instep', answer: 'Baldung' },
                { question: 'Footsword', answer: 'Balkal' },
                { question: 'Left', answer: 'Wen' },
                { question: 'Right', answer: 'Orun' },
                { question: 'Side Kick', answer: 'Yop Chagi' },
                { question: 'Side Piercing Kick', answer: 'Yop Cha Jirugi' },
                { question: 'Outer Forearm Wedging Block', answer: 'Bakat Palmok Hechyo Makgi' },
                { question: 'Straight Fingertip Thrust', answer: 'Sun Sonkut Tulgi' },
                { question: 'Backfist High Side Strike', answer: 'Dung Joomok Nopundae Yop Taerigi' },
                { question: 'Three-Step Sparring', answer: 'Sambo Matsogi' }
            ]
        }
    ],
    practical: [
        {
            title: 'Practical Elements',
            items: [
                {
                    question: 'Walking Stance Straight Fingertip Thrust, Pivot and Release Wrist',
                    answer: 'Forward x 4'
                },
                {
                    question: 'Walking Stance Outer Forearm Wedging Block',
                    answer: 'Backwards x 4'
                },
                {
                    question: 'Middle Front Snap Kick, Walking Stance Obverse Middle Punch, Reverse Middle Punch (Fast Motion)',
                    answer: 'Forward x 4'
                },
                {
                    question: 'Side Piercing Kick, L Stance Backfist High Side Strike',
                    answer: 'Forward x 4'
                }
            ]
        },
        {
            title: 'Power',
            items: [
                {
                    question: 'Side Piercing Kick',
                    answer: 'Target / Kick Shield'
                }
            ]
        },
        {
            title: 'Pattern',
            items: [
                {
                    question: 'Chon-Ji',
                    answer: ' '
                },
                {
                    question: 'Dan-Gun',
                    answer: ' '
                }
            ]
        },
        {
            title: 'Self Defence',
            items: [
                {
                    question: 'Single Lapel Grab - Release or deal with attacker',
                    answer: 'Under 13\'s'
                },
                {
                    question: 'Twin Lapel Grabs - Release or deal with attacker',
                    answer: 'Over 13\'s'
                },
                {
                    question: 'Situational - Front Kicks (Block / Dodge)',
                    answer: 'All Ages'
                }
            ]
        },
        {
            title: 'Sparring',
            items: [
                {
                    question: 'Three-Step Sparring',
                    answer: 'Sequences 1-3'
                },
                {
                    question: 'Free Sparring',
                    answer: 'Blocking and Leading Leg'
                }
            ]
        }
    ]
};
